import { render, staticRenderFns } from "./ListagemOcorrenciaBotoesAcoes.vue?vue&type=template&id=2e11b79c&scoped=true"
import script from "./ListagemOcorrenciaBotoesAcoes.vue?vue&type=script&lang=js"
export * from "./ListagemOcorrenciaBotoesAcoes.vue?vue&type=script&lang=js"
import style0 from "./ListagemOcorrenciaBotoesAcoes.vue?vue&type=style&index=0&id=2e11b79c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e11b79c",
  null
  
)

export default component.exports